import classes from './Tooltip.module.scss'

import { useState } from 'react'

export const Tooltip = ({ children, direction = 'top', content, delay }) => {
  console.log(direction)
  let timeout
  const [active, setActive] = useState(false)

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true)
    }, delay || 400)
  }

  const hideTip = () => {
    clearInterval(timeout)
    setActive(false)
  }
  return (
    <div
      className={`${classes.tooltip__wrapper} `}
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {children}
      {active && (
        <div
          className={`${classes.tooltip__wrapper__tip} ${classes[direction]}`}
        >
          {content}
        </div>
      )}
    </div>
  )
}
